import CompanyUsersCollection from "./collection";
import ApiCompanyUser from "../../gd/api/company/company-user";
import {SortDirection} from "../../data-structures/sort";


export default class SessionCompanyUsersDeleted extends CompanyUsersCollection {

    public isLoaded         : boolean = false;

    constructor(models:any) {
        super(models);
    }




    async load(): Promise<void> {

        if (this.isLoaded) {
            return
        }

        const response = await ApiCompanyUser.deletedCompanyUsersList().promise()
        this.resetFromJson(response)

        this.sortBy(gd.fields.companyUser.name, SortDirection.ASC)

        this.isLoaded = true;

    }


}
